import gql from 'graphql-tag';

export default gql`
  fragment ShowOrderItemFragment on OrderItem {
    ... on ShowOrderItem {
      id
      type
      show {
        date
        location
        categoryCode
        categoryName
        meta
        productName
        productDescription
      }
      quantity
      price {
        total {
          amount
          currency
        }
        subtotal {
          amount
          currency
        }
        taxesAndFees {
          amount
          currency
        }
      }
    }
  }
`;
